import routesList from '~/content/routes.json'
import { getFirstQueryValue } from '~/utils/query'
import { stripEndingSlash } from '~/utils/urls'

const CAREERS_JOBS_PATH = '/careers/jobs'
const JOB_POST_PATH_PREFIX = '/jobs/'
const PROSPECT_POST_PATH_PREFIX = '/prospects/'

const publicGreenhouseRoutes = routesList.filter(
  route =>
    (route.collection === 'jobs' && route.url.startsWith(JOB_POST_PATH_PREFIX)) ||
    (route.collection === 'prospects' && route.url.startsWith(PROSPECT_POST_PATH_PREFIX))
)

export default defineNuxtRouteMiddleware(to => {
  const greenhouseJobId = getFirstQueryValue(to.query.gh_jid)

  if (!greenhouseJobId) {
    return
  }

  const normalizedPath = stripEndingSlash(to.path)
  const isPublicJobsPage = normalizedPath === CAREERS_JOBS_PATH
  const isPublicJobPost = normalizedPath.startsWith(JOB_POST_PATH_PREFIX)
  const isPublicProspectPost = normalizedPath.startsWith(PROSPECT_POST_PATH_PREFIX)

  if (!isPublicJobsPage && !isPublicJobPost && !isPublicProspectPost) {
    return
  }

  const targetRoute = publicGreenhouseRoutes.find(route => route.id === greenhouseJobId)

  if (!targetRoute || normalizedPath === targetRoute.url) {
    return
  }

  return navigateTo({
    path: targetRoute.url,
    query: to.query,
    hash: to.hash
  })
})
